import InputCreditCard from './InputCreditCard';

export default InputCreditCard;
